export default {
  name: "Registration",
  path: "/registration",
  component: () => import("@/views/Registration")
};
